module.exports = __webpack_public_path__ + "static/media/gallery15.af2711fa.webp";